// Per-video deep content (first-principles derivations and extra quiz questions), keyed by video index.
import module1 from './module-1.js';
import module2 from './module-2.js';
import module3 from './module-3.js';
import module4 from './module-4.js';
import module5 from './module-5.js';
import module6 from './module-6.js';
import module7 from './module-7.js';
import module8 from './module-8.js';
import module9 from './module-9.js';
import module10 from './module-10.js';
import module11 from './module-11.js';

export const deepContentByIndex = Object.assign(
  {},
  module1,
  module2,
  module3,
  module4,
  module5,
  module6,
  module7,
  module8,
  module9,
  module10,
  module11
);
